import { render, staticRenderFns } from "./card-popular-review-loader.vue?vue&type=template&id=d569adf8&scoped=true"
import script from "./card-popular-review-loader.vue?vue&type=script&lang=js"
export * from "./card-popular-review-loader.vue?vue&type=script&lang=js"
import style0 from "./card-popular-review-loader.vue?vue&type=style&index=0&id=d569adf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d569adf8",
  null
  
)

export default component.exports